import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { Observable } from "rxjs";
import { PermissionsHelper } from "src/app/helpers/Permission";

@Injectable({
  providedIn: "root",
})
export class OpentokService {
  constructor(private api: ApiService, private permission: PermissionsHelper) {}

  public checkApplication(leadId): Observable<any> {
    return this.api.get("/opentok/check-application/" + leadId, {});
  }

  public end(body): Observable<any> {
    return this.api.post("/leads/opentok/end", {
      body,
      headers: {
        Permissions: this.permission.getJWT("leads"),
      },
    });
  }

  public decline(body): Observable<any> {
    return this.api.post("/leads/opentok/decline", {
      body,
      headers: {
        Permissions: this.permission.getJWT("leads"),
      },
    });
  }
}
